import { useEffect, useState } from 'react'

/**
 * useDidMountValue returns the value of mounted
 */
export const useDidMountValue = () => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (!mounted) {
      setMounted(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return mounted
}
